var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.095 2.763c-.444-.375-1.053-.702-1.809-.972-1.427-.51-3.305-.79-5.286-.79s-3.859.281-5.286.79c-.756.27-1.365.597-1.809.972C.157 3.395 0 4.056 0 4.5v1c0 .265.105.52.293.707l.5.5a1 1 0 0 0 1.078.221l2.5-1A1 1 0 0 0 5 5V3.256A17 17 0 0 1 8 3c1.059 0 2.085.089 3 .256V5c0 .409.249.777.629.928l2.5 1a1 1 0 0 0 1.078-.221l.5-.5A1 1 0 0 0 16 5.5v-1c0-.444-.157-1.106-.905-1.737"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.931 12.44a18.4 18.4 0 0 0-1.006-2.618c-.904-1.872-2.426-2.821-4.426-2.821h-3c-2 0-3.522.949-4.426 2.821-.624 1.293-.99 2.565-1.006 2.618-.188.656-.085 1.311.281 1.797s.968.764 1.65.764h10c.683 0 1.284-.278 1.65-.764s.469-1.14.281-1.797zM8 13a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 13"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.svg";